// DS3.8
import React from 'react';
import c from 'classnames';
import readableFileSize from 'filesize';
import SmartAttachmentIcon from '../Icons/SmartAttachment';
import { IconSize } from '../Icons/IconWrap';
import s from './AttachedFile.scss';
const AttachedFile = ({ className, name, size, type, width, height, previewUrl, preview, middleSlot, rightSlot })=>{
    const nameParts = name.split('.');
    const extension = nameParts.pop();
    const nameWithoutExtension = nameParts.join('.');
    const renderIcon = ()=>{
        if (preview) {
            return preview;
        }
        if (previewUrl) {
            return /*#__PURE__*/ React.createElement("div", {
                className: s['preview-icon'],
                style: {
                    backgroundImage: `url(${previewUrl})`
                }
            });
        }
        return /*#__PURE__*/ React.createElement(SmartAttachmentIcon, {
            className: s['icon'],
            size: IconSize.SMALLER,
            type: type
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, renderIcon(), /*#__PURE__*/ React.createElement("div", {
        className: s['filename'],
        title: nameWithoutExtension
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['name']
    }, nameWithoutExtension, extension ? '.' : ''), /*#__PURE__*/ React.createElement("span", {
        className: s['extension']
    }, extension)), /*#__PURE__*/ React.createElement("div", {
        className: s['middle-slot']
    }, middleSlot || /*#__PURE__*/ React.createElement(React.Fragment, null, readableFileSize(size), width && height ? ` - ${width} x ${height}` : null)), /*#__PURE__*/ React.createElement("div", {
        className: s['right-slot']
    }, rightSlot));
};
AttachedFile.displayName = 'AttachedFile';
export default AttachedFile;
